import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconForthSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="forward solid">
            <path
                d="M18 12L9 18L9 6L18 12Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconForthSolid16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="forward solid">
            <path
                d="M12 8L6 12L6 4L12 8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
